import React from 'react';

const StatusesContext = React.createContext({});

export default StatusesContext;
